/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Step_MapInputs */



/**
* | output |
* | --- |
* | "Match columns" |
*
* @param {Team_Manager_Import_Step_MapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_step_map = /** @type {((inputs?: Team_Manager_Import_Step_MapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Step_MapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Colonnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spalten zuordnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colonne")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Столбцы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Columnas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("匹配列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("列の対応")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कॉलम मिलाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colunas")
	return /** @type {LocalizedString} */ ("Match columns")
});